import React from "react";
import { AlertTriangle } from "lucide-react";
import { fmtMoney } from "@/lib/currency";

/**
 * BudgetWarning — subtle amber "Over budget" pill.
 * Only renders when spent > budget && budget > 0. Uses the passed `currency`
 * so it never fabricates a "$" prefix on non-USD projects (COP, EUR, etc.).
 */
export default function BudgetWarning({ budget, spent, currency = "USD", className = "", label = "Over budget" }) {
  const b = Number(budget) || 0;
  const s = Number(spent) || 0;
  if (b <= 0 || s <= b) return null;
  const over = s - b;
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium bg-amber-500/10 text-amber-300 border border-amber-500/25 ${className}`}
      data-testid="over-budget-badge"
      title={`Spent ${fmtMoney(s, currency)} against a ${fmtMoney(b, currency)} budget`}
    >
      <AlertTriangle className="w-3 h-3" strokeWidth={2.25}/>
      <span>{label} · {fmtMoney(over, currency, { maximumFractionDigits: 0 })} over</span>
    </div>
  );
}
